<template>
  <v-main>
    <v-btn
      color="primary"
      elevation="2"
      @click="profile = true"
      x-large
      style="text-transform: none"
    >
      <span>プロフィール画面を開く：{{ currentName }}</span>
    </v-btn>
    <!-- コンポーネント -->
    <profile_display
        :profile="profile"
        :profuid="uid"
        device="sp"
        @closeProfile="closeProfile"
      />
  </v-main>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import profile_display from "../components/profile/profile_display.vue";

export default {
  data() {
    return {
      db: null,
      profile: false,
    };
  },
  components: {
    profile_display,
  },
  created() {
    this.db = firebase.firestore();
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    currentName() {
      return this.$store.state.auth?.user?.displayName;
    },
  },
  methods: {
    closeProfile() {
      this.profile = false;
    },
  },
};
</script>
